<template>
    <div>

        <div>
            <p>L'organisateur vous propose de vous inscrire sur la liste d'attente pour un parcours. Si un
                participant se désiste et met son dossard en vente, vous serez notifié par email. Votre position dans la
                liste d'attente est définie par l'ordre d'inscription.</p>
            <p>
                Grace au lien fourni dans le mail, vous pourrez racheter le dossard. <b>Ce lien est valable 24
                    heures</b>.
                Passé ce
                délai, le lien sera envoyé au suivant participant de la liste d'attente, et vous perdrez votre place.
                Vous
                aurez la possibilité de vous réinscrire sur la liste d'attente, si vous le souhaitez. </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListeAttenteDescription',
    props: {
    },
}
</script>
